import objectHash from 'object-hash';

type CommandHistory = Array<{ key: string; timestamp: number }>;
let commandHistory: CommandHistory = [];

const SECONDS_TO_CHECK = 5;
const NUM_COMMON_COMMANDS = 10;

const filterBombardment =
  (getKey: () => string) =>
  <T>(func: () => Promise<T>) => {
    const now = Date.now();
    const key = getKey();
    commandHistory.push({ key, timestamp: now });

    // Mutate the array to keep the array size reasonable
    commandHistory = commandHistory.filter((item) => now - item.timestamp < 1000 * SECONDS_TO_CHECK);

    const filteredCommands = commandHistory.filter((item) => key === item.key);

    if (filteredCommands.length >= NUM_COMMON_COMMANDS) {
      throw new Error(`Too many same command in a short time: ${key}`);
    }

    return func();
  };

const hash = (obj: Parameters<typeof objectHash>[0]) => objectHash(obj, { algorithm: 'md5', encoding: 'base64' });

export { filterBombardment, hash };
